export default "__VITE_ASSET__N3XTpR92__"